import { useSelector } from "react-redux";

import { getHasSaleWatcherInCurrentSale } from "selectors";

export const ForSaleWatcherInCurrentSale = ({ children }) => {
  return useSelector(getHasSaleWatcherInCurrentSale) ? children : null;
};
